export default ['adriana.molvinger@foodforjoe.es', 'dana@foodforjoe.es', 'data@foodforjoe.com'];
